var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.clickedOutside,
          expression: "clickedOutside",
        },
      ],
      ref: "userMenu",
      staticClass: "emd-dropdown _position_right",
    },
    [
      _c(
        "div",
        {
          staticClass: "emd-dropdown__trigger",
          class: { _active: _vm.showUserMenu },
          on: { click: _vm.toggleUserMenu },
        },
        [
          _c(
            "span",
            [
              _c(
                "emd-tippy",
                {
                  staticClass: "emd-action-button _has-tooltip",
                  attrs: {
                    id: "profile",
                    tag: "button",
                    type: "action-button",
                    content: _vm.$t("profile"),
                  },
                },
                [
                  _c("i", {
                    staticClass: "emd-action-button__icon uil uil-user",
                  }),
                  _c("i", {
                    staticClass: "emd-action-button__arrow uil uil-angle-down",
                  }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "emd-dropdown__content",
          class: { _active: _vm.showUserMenu },
        },
        [
          _c("div", { staticClass: "emd-dropdown__content__item" }, [
            _c("span", { staticClass: "emd-badge eu-mt_1" }, [
              _vm._v(_vm._s(_vm.permission)),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "emd-text _color_default _type_label _size_tiny eu-ma_2",
              },
              [_vm._v(_vm._s(_vm.$t("profile")))]
            ),
          ]),
          _c("ul", [
            _c("li", { staticClass: "emd-dropdown__content__item" }, [
              _c(
                "a",
                {
                  staticClass: "emd-text _color_default",
                  attrs: { href: _vm.urlProfile },
                },
                [
                  _c(
                    "p",
                    { staticClass: "emd-dropdown__content__item__text" },
                    [
                      _vm._m(0),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.user.first_name) +
                            " " +
                            _vm._s(_vm.user.last_name)
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("li", { staticClass: "emd-dropdown__content__item" }, [
              _c(
                "a",
                {
                  staticClass: "emd-text _color_danger",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.triggerLogout },
                },
                [
                  _c(
                    "p",
                    { staticClass: "emd-dropdown__content__item__text" },
                    [
                      _c("i", { staticClass: "uil uil-sign-out-alt" }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("logout")))]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "emd-text _color_nonessential" }, [
      _c("i", { staticClass: "uil uil-user" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }